import { render, staticRenderFns } from "./SignBatchEfirma.vue?vue&type=template&id=27206b3b&scoped=true"
import script from "./SignBatchEfirma.vue?vue&type=script&lang=js"
export * from "./SignBatchEfirma.vue?vue&type=script&lang=js"
import style0 from "./SignBatchEfirma.vue?vue&type=style&index=0&id=27206b3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27206b3b",
  null
  
)

export default component.exports